import { create } from "zustand";

// "run" — feature-extraction or existing-part edit (has a parts_ai.run).
// "comparison" — two parts being compared (no run).
// "search" — natural-language parts search (no run, linked-parts set lives on
//            parts_ai.search_dialogue).
export type DialogueKind = "run" | "comparison" | "search";

type State = {
  partsAIRunId: number | undefined;
  dialogueId: number | undefined;
  dialogueKind: DialogueKind | undefined;
};

type Action = {
  setPartsAIRunId: (id: number | undefined) => void;
  setDialogueId: (id: number | undefined) => void;
  setDialogueKind: (kind: DialogueKind | undefined) => void;
  reset: () => void;
};

const initialState: State = {
  partsAIRunId: undefined,
  dialogueId: undefined,
  dialogueKind: undefined,
};

export const usePartsAIStore = create<State & Action>()((set) => ({
  ...initialState,
  setPartsAIRunId: (id) => set({ partsAIRunId: id }),
  setDialogueId: (id) => set({ dialogueId: id }),
  setDialogueKind: (kind) => set({ dialogueKind: kind }),
  reset: () => set(initialState),
}));
